module.exports = __webpack_public_path__ + "static/media/signature.461ab508.svg";